import React from "react";
import Footer from "../../Footer";
import About from "../About";
import Main from "./Main";

export default function AboutPage() {
    return (
        <>
            <About/>
            <Main/>
            <Footer/>
        </>
    );
}
